export const queryParams = (state, action) => {
  return {
    ...state,
   ...action.params,
  };
};
